import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LanguageProvider } from "@/context/LanguageContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Profile from "@/pages/Profile";
import MCQTraining from "@/pages/MCQTraining";
import LiveCall from "@/pages/LiveCall";
import NCRPForm from "@/pages/NCRPForm";
import CaseStudies from "@/pages/CaseStudies";
import Reference from "@/pages/Reference";
import SOPGuide from "@/pages/SOPGuide";
import Analytics from "@/pages/Analytics";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminUsers from "@/pages/AdminUsers";
import AdminAnalytics from "@/pages/AdminAnalytics";
import AdminContent from "@/pages/AdminContent";

function Home() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
}

const wrap = (el, adminOnly = false) => (
  <ProtectedRoute adminOnly={adminOnly}>
    <Layout>{el}</Layout>
  </ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster position="top-right" richColors />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/dashboard" element={wrap(<Dashboard />)} />
              <Route path="/mcq" element={wrap(<MCQTraining />)} />
              <Route path="/live-call" element={wrap(<LiveCall />)} />
              <Route path="/ncrp-form" element={wrap(<NCRPForm />)} />
              <Route path="/case-studies" element={wrap(<CaseStudies />)} />
              <Route path="/reference" element={wrap(<Reference />)} />
              <Route path="/sop" element={wrap(<SOPGuide />)} />
              <Route path="/analytics" element={wrap(<Analytics />)} />
              <Route path="/profile" element={wrap(<Profile />)} />
              <Route path="/admin" element={wrap(<AdminDashboard />, true)} />
              <Route path="/admin/users" element={wrap(<AdminUsers />, true)} />
              <Route path="/admin/content" element={wrap(<AdminContent />, true)} />
              <Route path="/admin/analytics" element={wrap(<AdminAnalytics />, true)} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
